var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"landing"},[_c('Hero'),_c('NftPlayground'),_c('Features'),_c('MeetYourSideKick'),_c('Rarity'),_c('Minting'),_c('SneakerLegacy'),_c('Milestones'),_c('Roadmap'),_c('Faq')],1)}
var staticRenderFns = []

export { render, staticRenderFns }